var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 48.78a1.5 1.5 0 01-1.06-2.56L61.5 15.66a1.5 1.5 0 012.12 2.12L33.06 48.34a1.5 1.5 0 01-1.06.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48.78a1.5 1.5 0 01-1.06-.44L.38 17.78a1.5 1.5 0 012.12-2.12l30.56 30.56A1.5 1.5 0 0132 48.78z"
  })));
}
export default SvgDownArrow;